export default "__VITE_ASSET__CJvCeCgk__"